import { useEffect, useState, } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIsLoading, getMenus, getResources } from "../../selectors";
import { getModulesMenusAction, updateModuleMenuAction } from "../../actions";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString } from "@icarius-localization/strings";
import { RESET_ALL } from "../../actionTypes";

const useMenus = () => {

    const [selectedItem, setSelectedItem] = useState(null);
    const [formIsOpen, setFormIsOpen] = useState(false);

    const dispatch = useDispatch();
    const isLoading = useSelector(getIsLoading);
    const menus = useSelector(getMenus);
    const resources = useSelector(getResources);

    useEffect(() => {
        dispatch(getModulesMenusAction());

        return () => {
            dispatch({ type: RESET_ALL });
        }
    }, [dispatch])

    const handleOpenUpdateForm = (gridRef) => {
        let selectedRows = gridRef.api.getSelectedRows();
        if (selectedRows.length !== 1) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectOneRow"), severity: "warning" }));
            return;
        }

        setSelectedItem(selectedRows[0]);
        setFormIsOpen(true);
    }

    const handleCloseForm = () => {
        setSelectedItem(null);
        setFormIsOpen(false);
    }

    const handleUpdate = (dataToSend) => {
        dispatch(updateModuleMenuAction(selectedItem.id, dataToSend))
            .then((resp) => {
                if (resp?.status === 200) {
                    handleCloseForm();
                }
            });
    }

    const state = {
        selectedItem,
        formIsOpen,
    }

    const handlers = {
        handleOpenUpdateForm,
        handleCloseForm,
        handleUpdate,
    }

    return {
        isLoading,
        menus,
        resources,
        state,
        handlers,
    }
}

export default useMenus;